
import React from 'react';

const pillars = [
  {
    icon: 'ri-film-line',
    title: 'Film',
    description:
      'From concept to screen, we produce compelling narratives that captivate audiences worldwide.',
  },
  {
    icon: 'ri-music-2-line',
    title: 'Entertainment',
    description:
      'We create immersive experiences that push the boundaries of live events, music, and media.',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Technology',
    description:
      'Building next-generation digital products and platforms that shape how people interact with content.',
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-3xl mb-20">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-400 font-medium mb-4">
            What We Do
          </p>
          <h2
            className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            We operate at the crossroads of creativity and innovation.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {pillars.map((pillar, index) => (
            <div
              key={index}
              className="group p-8 rounded-2xl border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-900 text-white mb-6 group-hover:scale-110 transition-transform">
                <i className={`${pillar.icon} text-xl`}></i>
              </div>
              <h3
                className="text-xl font-bold text-gray-900 mb-3"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {pillar.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
